import React from "react";
import { Box } from "@mui/material";
import { isMobile } from "react-device-detect";

import CommentOptionBar from "./CommentOptionBar";

const CommentOption = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickMenu = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(e.target);
  };

  // const longPressEvent = useLongPress(handleClickMenu);

  return (
    <>
      <Box
        onClick={isMobile ? handleClickMenu : null}
        onContextMenu={isMobile ? null : handleClickMenu}
      >
        {props.children}
      </Box>
      <CommentOptionBar
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        objCm={props.cmData}
      />
    </>
  );
};

export default CommentOption;
